import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import ArticleCard from '../../cards/ArticleCard';
import BaseVideoCard from '../../cards/VideoCard';
import Link from '../../Link';

const transformVideoItem = (item, type) => ({
  title: item.title,
  image: item.imageUrl,
  publishDate: item.publishDate,
  brandName: item.brand.name,
  mediaType: type.toLowerCase(),
});

const transformArticleItem = (item) => ({
  title: item.title,
  publishDate: item.publishDate,
  thumbnail: {
    url: item.imageUrl,
  },
  brand: item.brand.name,
  requiresMembership: item.requiresMembership,
  commentsEnabled: item.commentsEnabled,
});

const SearchResultItem = ({ type, uri, index, ...item }) => {
  let element;

  if (['Audio', 'Video'].includes(type)) {
    const videoItem = transformVideoItem(item, type);
    element = <BaseVideoCard {...videoItem} />;
  }

  if (['Article', 'Page', 'Question'].includes(type)) {
    const articleItem = transformArticleItem(item);
    element = <ArticleCard {...articleItem} />;
  }

  if (!element) {
    return null;
  }

  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 3"
      rowStartLg="span 3"
      key={uri}
    >
      <Link
        href={uri}
        category="Zoeken"
        label={`${type}-${index}`}
        action="click"
        disableNextLink="true"
      >
        {element}
      </Link>
    </GridItem>
  );
};

SearchResultItem.propTypes = {
  title: PropTypes.string.isRequired,
  publishDate: PropTypes.string,
  brand: PropTypes.string,
  type: PropTypes.string,
  uri: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  index: PropTypes.number.isRequired,
};

SearchResultItem.defaultProps = {
  brand: null,
  publishDate: Date.now(),
  imageUrl: null,
  type: null,
};

export default SearchResultItem;
